import { render } from "./MdTooltip.vue?vue&type=template&id=36d68eea"
import script from "./MdTooltip.vue?vue&type=script&lang=js"
export * from "./MdTooltip.vue?vue&type=script&lang=js"

import "./MdTooltip.vue?vue&type=style&index=0&id=36d68eea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__